import React, { useEffect } from "react";
import Navbar from "../../AcuvisorCustomerApp/HealthInsurance/Components/Navbar/Navbar";
import thankImage from "./images/thankyou.jpg";
import { useNavigate } from "react-router-dom";

const HealthThankYouPage = () => {
  const navigate = useNavigate();
  useEffect(() => {
    localStorage.clear();
    console.log("localStorage: ", localStorage);
  }, []);

  const handleButtonClick = () => {
    console.log("Button clicked!");
    navigate(`/health-insurance/`);

  };

  return (
    <div>
      <Navbar />
      <div className="flex justify-center lg:px-24 w-screen">
        <div className="lg:w-3/5 w-full bg-slate-200 rounded-md m-4 p-4 flex flex-col md:flex-row lg:flex-row justify-center items-center gap-4">
          <img
            src={thankImage}
            alt="Policy completed"
            className="w-full md:w-1/2 lg:w-1/2 rounded-md"
          />
          <div className="text-center bg-white p-4 rounded-md">
            <div className="text-2xl mb-3">Thank you!</div>
            <div className="mb-4">
              Your policy has been completed... Please proceed to Homepage for
              further
            </div>
            <button
              onClick={handleButtonClick}
              className="bg-gradient-to-r from-blue-500 to-green-500 hover:bg-gradient-to-r hover:to-blue-500 hover:from-green-500 text-white font-bold py-2 px-4 rounded"
            >
              Home Page
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HealthThankYouPage;
